import React, { type FC } from 'react'
import type FilterOption from '../../../interfaces/FilterOption'
import { ActiveFiltersContainer, StyledChip } from './Filters.style'
import ClearIcon from '@mui/icons-material/Clear'
import { RemoveActiveFilterAction, SetAlarmsFilterAction } from '../../../redux/meter-table/meter-table-actions'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { type RootState } from '../../../redux/store'

export const ActiveAlarmFilter: FC = () => {
  const dispatch = useAppDispatch()

  const data = useAppSelector((state: RootState) => state.data)

  const handleDelete = (filter: FilterOption): void => {
    dispatch(RemoveActiveFilterAction({ data: filter }))
    dispatch(SetAlarmsFilterAction({ alarmsFilter: false }))
  }

  return (
        <ActiveFiltersContainer>
            {data.activeFilters.map((i: FilterOption) => (
                <StyledChip deleteIcon={<ClearIcon/>} key={i.name} label={i.name} onDelete={() => {
                  handleDelete(i)
                }}/>
            ))}
        </ActiveFiltersContainer>)
}
